import React from "react";

import Seat from "@busbud/design-system-components/dist/Seat";
import type * as UDM from "@busbud/int-schemas/udm";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";
import type { PassengerSeatSelectionInstance } from "@app/types/seat-selection-types";

const useStyles = createStyles(() => ({
  seat: {
    pointerEvents: "none"
  }
}));

interface Props {
  passengers: PassengerSeatSelectionInstance[];
  seats: UDM.SeatCell[];
}

export const SelectedSeatsList: React.FC<Props> = props => {
  const { passengers, seats: selected_seats } = props;
  const { classes } = useStyles();

  const remaining_pending_seats = passengers.length - selected_seats.length;

  return (
    <div className="flex gap-050">
      {selected_seats.map(cell => (
        <Seat
          className={classes.seat}
          key={cell.id}
          state={
            cell.gender && cell.gender === "female"
              ? "unavailableWoman"
              : "unavailableMan"
          }
          seatNumber={cell.display_name}
          orientation="left"
        />
      ))}
      {[...Array(remaining_pending_seats)].map((_e, i) => (
        <Seat key={i} state="selected" orientation="left" />
      ))}
    </div>
  );
};
